export default __webpack_public_path__ + "static/media/hostaway_step3.caa377ea.jpg";